<script lang="ts">
    import ShortcodeFragment from "../ShortcodeFragment.svelte"
    import { shortcodeComponents } from "./"

    export let slot: string

    let restP = Object.assign({}, $$props)
    delete restP.class
</script>

<div class="{$$props.class}" {...restP}>
    <ShortcodeFragment components="{shortcodeComponents}" html="{slot}" />
</div>
